/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimDocumentRequestDto } from '../models/clm-claim-document-request-dto';


/**
 * the ClaCommandCreateDocument API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCommandCreateDocumentService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createDocuments
   */
  static readonly CreateDocumentsPath = '/claim/{claimId}/document';

  /**
   * Create claim document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDocuments$Response(params: {
    claimId: string;
    body: ClmClaimDocumentRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCommandCreateDocumentService.CreateDocumentsPath, 'post');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create claim document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDocuments(params: {
    claimId: string;
    body: ClmClaimDocumentRequestDto
  },
  context?: HttpContext

): Observable<void> {

    return this.createDocuments$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
